import React from 'react';
import PropTypes from 'prop-types';

const Box = ({children, className = '', noBorder, noPadding}) => {
  return (
    <div
      className={`br2 ${noBorder ? '' : 'ba b--near-white'} ${
        noPadding ? '' : 'pt4 ph3 pb3'
      } mv4 bg-white ${className}`}>
      {children}
    </div>
  );
};

Box.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  noBorder: PropTypes.bool,
  noPadding: PropTypes.bool,
};

export default Box;
